<template>
<div>
  <div class="form-group form-inline pull-left">
    <select v-model="numPages" class="form-control" @change="changeQty">
      <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
    </select> &nbsp;
    <input
      v-model="search"
      type="search"
      class="form-control"
      placeholder="Buscar"
      v-on:keyup="onChange"
    > &nbsp;
  </div>
  <div class="form-group form-inline pull-right">
    <date-picker
      v-model="date.start"
      lang="es"
      type="date"
      placeholder="Desde"
      required
      format="DD/MM/YYYY"
    ></date-picker>&nbsp;
    <date-picker
      v-model="date.end"
      lang="es"
      type="date"
      placeholder="Hasta"
      required
      format="DD/MM/YYYY"
    ></date-picker>&nbsp;
    <button class="btn btn-primary" @click="getVoids()">Buscar</button>&nbsp;
    <download-excel
      class="btn btn-primary"
      :data="filteredRqs"
      :fields="json_fields"
      :name="`${file_name}.xls`"
    >Descargar Excel</download-excel>&nbsp;
    <button class="btn btn-primary" @click="newVoid()" v-if="$can('add', 'Voids')">Nuevo</button>
  </div>
</div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['url', 'void', 'file_name', 'filteredRqs', 'json_fields'],
  data(){
    return{
      date: {
        start: moment().format('YYYY-MM-DD HH:mm:ss'),
        end: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      search: '',
      numPages: 100,
    }
  },
  methods: {
    newVoid(){
      this.$router.push(`/voids/${this.void}/new`)
    },
    getVoids(){
      this.$emit('getVoids', this.date)
    },
    onChange(e){
      this.$emit('searchText', e.target.value)
    },
    changeQty(e){
      this.$emit('changeQty', Number(e.target.value))
    }
  }
}
</script>

